import utils from '../../../../modules/utils';
import sendAdyenV2ActionResponse from '../../../actions/paymentActions/adyenV2/sendAdyenV2ActionResponse';
import store from '../../../store/store';

function isTokenReceived() {
  // Method UNSUPPORTED
  return false;
}

function isReturningFromHostedPage(queryParams) {
  return window.start.selectedPaymentMethod === 'ADYEN_V2' && !!utils.fn.getURIParam(queryParams, 'redirectResult');
}

function isProblemWithService(status) {
  return (status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage(queryParams) {
  const redirectResult = utils.fn.getURIParam(queryParams, 'redirectResult');
  return store.dispatch(sendAdyenV2ActionResponse({details: {redirectResult}}, true));
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
